import { render, staticRenderFns } from "./NPS.vue?vue&type=template&id=18fda8d5&"
import script from "./NPS.vue?vue&type=script&lang=js&"
export * from "./NPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports